import { equals } from 'ramda'

export const FREC = 'FREC'
export const PROMETHEUS = 'PROMETHEUS'

export const isPrometheus = equals(PROMETHEUS)
export const isFrec = equals(FREC)
